<script>
import Table from "@/components/layouts/Table.vue";
import { toBlob } from 'dom-to-image-more';

export default {
  name: "HtmlToImageForPdf",
  data() {
    return {
      htmlContent : '',
      devMode : false,
      compiledImages : [],
      pageHeights : []
    }
  },
  components: {Table},
  props : {
    chunkHeight : {
      type: Number,
      default : 954
    }
  },
  methods : {
    setHtmlContent(htmlContent) {
      this.htmlContent = htmlContent;
      return this;
    },
    setDevMode() {
      this.devMode = true;
      return this;
    },
    async getImageData() {
      return this.compiledImages;
    },
    async splitImageVertically(blob) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const { width, height } = img;
          const canvas = document.createElement('canvas');
          canvas.width = width;

          const chunks = [];
          let y = 0;

          const chunkHeight = this.chunkHeight;

          function processChunk() {
            const h = Math.min(chunkHeight, height - y);
            canvas.height = h;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, width, h);
            ctx.drawImage(img, 0, y, width, h, 0, 0, width, h);

            canvas.toBlob((partBlob) => {
              chunks.push(partBlob);
              y += h;
              if (y >= height) {
                resolve(chunks);
              } else {
                processChunk();
              }
            }, 'image/png');
          }

          processChunk();
        };

        img.src = URL.createObjectURL(blob);
      });
    },
    async generateTableToImage(heights) {
      const blob = await toBlob(this.$refs.tableContainer, {
        pixelRatio: 2,
        backgroundColor: 'white'
      });
      this.compiledImages = await this.splitImageVerticallyV2(blob, heights);

      if (this.devMode === false) {
        this.htmlContent = '';
      }

    },
    async splitImageVerticallyV2(blob, chunkHeightsArray = []) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const { width, height } = img;
          const canvas = document.createElement('canvas');
          canvas.width = width;

          const chunks = [];
          let y = 0;
          let chunkIndex = 0;

          function processChunk() {
            // Use height from array if provided, else fallback to default chunkHeight
            const chunkHeight = chunkHeightsArray.length > 0
              ? chunkHeightsArray[chunkIndex] || (height - y)  // fallback to remainder if array is too short
              : this.chunkHeight;

            const h = Math.min(chunkHeight, height - y);
            canvas.height = h;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, width, h);
            ctx.drawImage(img, 0, y, width, h, 0, 0, width, h);

            canvas.toBlob((partBlob) => {
              chunks.push(partBlob);
              y += h;
              chunkIndex++;
              if (y >= height) {
                resolve(chunks);
              } else {
                processChunk();
              }
            }, 'image/png');
          }

          processChunk = processChunk.bind(this); // Ensure `this.chunkHeight` works if needed
          processChunk();
        };

        img.src = URL.createObjectURL(blob);
      });
    }

  }
}
</script>

<template>
  <div ref="tableContainer" class="pb-1">
    <div class="mb-4" v-html="htmlContent"></div>
  </div>
</template>

<style scoped>

</style>
